module.exports = __webpack_public_path__ + "img/2-low.1e18c239.jpg";